module.exports = __webpack_public_path__ + "media/packs/images/flags/BN-86672c45444bef852b3aaa6bd7e1b0e6.svg";